/* eslint-disable react/jsx-pascal-case */
import React, { useRef, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import AppFormikInputFieldRadio from "utlis/helpers/forms/AppFormikInputFieldRadio";
import FeatherIcon from "feather-icons-react";
import { setGlobalLoading } from "redux/actions/actionCommon";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { ERROR_WHILE__NAME } from "utlis/AppMessages/AppMessages";
import { UNKNOWN_ERROR_OCCURED } from "utlis/AppMessages/AppMessages";
import { getCustomerAddresses } from "utlis/Apis/Customers_API";
import FormPurchaseOrders__VendorInfo from "./FormVendorInformation/FormPurchaseOrders__VendorInfo";
import FormPurchaseOrdersShippingAddress from "./FormVendorInformation/FormPurchaseOrdersShippingAddress";
import FormPurchaseOrdersBillingAddress from "./FormVendorInformation/FormPurchaseOrdersShippingAddress";
import { VENDOR_ADDED_SUCCESSFULLY } from "utlis/AppMessages/AppMessages";
import { ERROR_WHILE_CREATING_VENDOR } from "utlis/AppMessages/AppMessages";
import { useFormik } from "formik";
import { createAddressIntialValues, createAddressVS, createVendorIntialValues, createVendorVS } from "./Helper";
import { addVendor } from "utlis/Apis/Vendor_API";

function PurchaseOrdersFormVendorInfoView(props) {
  const { authState, vendor, setVendor, countries, vendors,
    bAddress, sAddress, setBAddress, setSAddress, setAddresses, addresses, saveAddresses } = props
  const submitButtonRef = useRef(null)
  const sAddressButtonRef = useRef(null)
  const bAddressButtonRef = useRef(null)
  const [first_name, setFirst_name] = useState(' ');
  const [email, setEmail] = useState('');
  const [foundVendors, setFoundVendors] = useState(false);
  const [createButtonLoading, setCreateButtonLoading] = useState(false)
  const [isSame, setSame] = useState(false)

  const goStep1 = () => {
    window.scrollTo(0, 0)

    if (vendor.isNew) {
      submitButtonRef.current.click()
    } else if (!vendor.vendor_id) {
      toast.error("Please select or create a vendor")
    } else {
      bAddressButtonRef.current.click()
      // props.setGoSteps(1)
    }
  }
  const next = (address) => {
    if (vendor.vendor_id) {
      props.setGoSteps(1)
      saveAddresses(address)
    } else {
      onCreateFormSubmit(vendor)
    }
  }

  const getVendorAddresses_ = (vendor_id) => {
    if (!vendor_id) {
      return
    }
    const headers = {
      "Authorization": `Bearer ${authState.commonToken}`,
      "Api-Token": authState.apiToken,
      "Access-Token": "",
      // "Store-Id": authState.storeId,
    }
    getCustomerAddresses(headers, vendor_id).then(res => {
      const addressData = res.data
      if (addressData.success) {
        setAddresses(arr => addressData.data)
        setBAddress(addressData.data.filter(e => e.is_default && e.address_type === "Billing")[0] || addressData.data.filter(e => e.address_type === "Billing")[0] || {})
        setSAddress(addressData.data.filter(e => e.is_default && e.address_type === "Shipping")[0] || addressData.data.filter(e => e.address_type === "Shipping")[0] || {})

      }
      if (addressData.error) {
        console.log('Error occured while loading admin groups!', res)
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} getAddresses `, err.message)
    })
  }


  const filter = (e) => {
    const keyword = e.target.value;

    if (keyword !== '') {
      const results = vendors.filter((vendor) => {
        return vendor.first_name.toLowerCase().startsWith(keyword.toLowerCase()) ||
          vendor.email.toLowerCase().startsWith(keyword.toLowerCase());
      });
      setFoundVendors(results)
    } else {
      setFoundVendors(false);
      setBAddress(addresses);
    }
    setFirst_name(keyword);
    setEmail(keyword);
  };


  const onCreateFormSubmit = values => {
    if (values) {
      setGlobalLoading(true)
      setCreateButtonLoading(true)
      const headers = {
        "Authorization": `Bearer ${authState.commonToken}`,
        "Api-Token": authState.apiToken,
        "Access-Token": "",
        // "Store-Id": authState.storeId,
      }
      addVendor(headers, values).then(res => {
        setGlobalLoading(false)
        const addingVendor = res.data
        if (addingVendor.success) {
          values.vendor_id = res.data.vendor_id
          onSuccess(values)

        } else if (addingVendor.error) {
          onError(res)
        }
      }).catch(err => {
        console.log(`${ERROR_WHILE__NAME} createVendor `, err.message)
        onCatch()
      })
    }
  }

  const onError = (res) => {
    console.log(ERROR_WHILE_CREATING_VENDOR, res)
    setCreateButtonLoading(false)
    toast.dismiss();
    toast.error(ERROR_WHILE_CREATING_VENDOR, {
      autoClose: 3000,
    })
  }
  const onCatch = () => {
    toast.dismiss();
    toast.error(UNKNOWN_ERROR_OCCURED, {
      autoClose: 2500,
      onClose: () => {
        setGlobalLoading(false)
        setCreateButtonLoading(false)
      }
    })

  }
  const onSuccess = (data) => {
    setCreateButtonLoading(false)
    data.isNew = false
    setVendor(data)
    cformik.resetForm()
    setAddresses(arr => [])
    setSAddress({})
    setBAddress({})

    // props.setGoSteps(1)
    toast.dismiss();
    toast.success(VENDOR_ADDED_SUCCESSFULLY, {
      autoClose: 2000,
      onClose: () => {
      }
    })
  }
  const handleFormSubmission = (ev) => {
    ev.preventDefault()
    submitButtonRef.current.click()
  }

  const cformik = useFormik({
    initialValues: { ...createVendorIntialValues({}) },
    validationSchema: createVendorVS,
    // onSubmit: (vendor_) => {
    //   setCustomer(vendor_)
    //   console.log("111")
    //   // bAddressButtonRef.current.click()
    // },
    onSubmit: onCreateFormSubmit,
    enableReinitialize: false,
    initialTouched: {}
  })

  const sformik = useFormik({
    initialValues: {
      ...createAddressIntialValues, ...sAddress, shipping_first_name: vendor.first_name,
      shipping_last_name: vendor.last_name, shipping_middle_name: vendor.middle_name,
    },
    validationSchema: createAddressVS,
    onSubmit: (address) => {
      setSAddress(address)
      next(address)
    },
    enableReinitialize: true,
    validate: () => {
      setSame(false)
    }
  })
  const aformik = useFormik({
    initialValues: {
      ...createAddressIntialValues, ...bAddress, shipping_first_name: vendor.first_name,
      shipping_last_name: vendor.last_name, shipping_middle_name: vendor.middle_name,
    },
    validationSchema: createAddressVS,
    onSubmit: (address) => {
      setBAddress(address)
      sAddressButtonRef.current.click()
    },
    enableReinitialize: true,
    validate: (values) => {
      setBAddress(values)
      setSame(false)
    }
  })

  return (
    <React.Fragment>
      <div id="sale-order-venderInfo">
        <div
          className="venderInfo-card">
          <div
            className="app-header-wrapper heading-sm mb-1">
            <p className="app-heading-bold text-capitalize app-heading-label">
              Vendor Information
            </p>
          </div>

          <div className="sale-order-for border st-border-light st-default-rounded-block pad-20-LR pad-20-T pad-20-B">
            <Col
              xs={12}
              md={9}
              lg={!vendor.isNew ? 6 : 12}
              className="px-0"
            >
              <form onSubmit={cformik.handleSubmit} noValidate autoComplete="off">
                <FormPurchaseOrders__VendorInfo
                  formik={cformik}
                  selectedVendor={vendor}
                  vendors={vendors}
                  first_name={first_name}
                  email={email}
                  foundVendors={foundVendors}
                  filter={filter}
                  setFoundVendors={bool => setFoundVendors(bool)}
                  setSelectedVendor_={setVendor}
                  addresses={addresses}
                  getVendorAddresses_={getVendorAddresses_}
                  bAddress={bAddress}
                  sAddress={sAddress}
                  setBAddress={bool => setBAddress(bool)}
                  setSAddress={bool => setSAddress(bool)}
                  setAddresses={setAddresses}
                />
                <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
              </form>
              {vendor.isNew &&
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    onClick={handleFormSubmission}
                    disabled={createButtonLoading}
                    className={`st-btn  st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-end`}
                  >Save Vendor</button>
                </div>
              }
            </Col>
          </div>
        </div>

        <Row className="customerInfo-addresses">
          <div className="app-card mb-3 mb-lg-4" style={{ width: "50%", paddingRight: 7.5, paddingLeft: 0 }}>
            <Row>
              <Col xs={12} md={9} lg={12} className="px-0">
                <div
                  className="app-header-aaddresses heading-sm pad-12-L" style={{ marginBottom: 12.5 }}>
                  <p>Billing Address</p>
                </div>
              </Col>
            </Row>

            <div className="app-card-content border st-border-light st-default-rounded-block pad-20-LR pad-20-T billing-address">
              <Col xs={12} md={9} lg={12} className="px-0">
                <form onSubmit={aformik.handleSubmit} noValidate autoComplete="off">
                  <FormPurchaseOrdersBillingAddress
                    formik={aformik}
                    countries={countries}
                    isDisabled={(!vendor.vendor_id || vendor.isNew)}
                  />
                  <button type="submit" ref={bAddressButtonRef} className="d-none">submit</button>
                </form>
              </Col>
            </div>
          </div>

          <div className="app-card mb-3 mb-lg-4 app-shipping-content" style={{ width: "50%", paddingLeft: 7.5, paddingRight: 0 }}>
            <Row style={{ marginBottom: "-24px" }}>
              <Col xs={12} md={9} lg={7} className="px-0">
                <div className="app-header-addresses heading-sm" style={{ marginBottom: 36 }}>
                  <p>Shipping Address</p>
                </div>
              </Col>
              <Col xs={12} md={9} lg={5} className="px-0">
                <div className="app-header-wrapper heading-sm"
                  style={{ float: "right" }}>
                  <AppFormikInputFieldRadio
                    stFormClass={
                      "st-form st-form-with-label-left d-flex flex-wrap align-items-center pb-0 same-as-billing"
                    }
                    formikFieldName={"sameAsBillingAddress"}
                    labelNameRight={"Same as Billing Address"}
                    isRound={true}
                    value={isSame}
                    onChange={e => {
                      if (e.target.checked) { setSAddress(bAddress) }
                      setSame(e.target.checked)
                    }}
                  />
                </div>
              </Col>
            </Row>

            <div className="app-card-content border st-border-light st-default-rounded-block pad-20-LR pad-20-T shipping-address">
              <Col xs={12} md={9} lg={12} className="px-0">
                <form onSubmit={sformik.handleSubmit} noValidate autoComplete="off">
                  <FormPurchaseOrdersShippingAddress
                    authState={authState}
                    formik={sformik}
                    countries={countries}
                    isDisabled={(!vendor.vendor_id || vendor.isNew)}
                  />
                  <button type="submit" ref={sAddressButtonRef} className="d-none">submit</button>
                </form>
              </Col>
            </div>
          </div>
          <div className="app-card-content bg-white  d-flex align-items-center justify-content-end bottom-btn">
            <button
              type="submit"
              className={`st-btn  st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-center`}
              disabled={createButtonLoading}
              onClick={() => {
                goStep1()
              }}
            >
              {createButtonLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <>
                  <span>Next</span>
                  <FeatherIcon
                    icon="arrow-right"
                    size="14"
                    className="icon ms-1"
                  />
                </>
              )}
            </button>
          </div>

        </Row>
      </div >
    </React.Fragment >
  );
}


const getDataFromStore = state => {
  return {
    authState: state.auth,
  };
}

const dispatchActionsToProps = dispatch => {
  return {
    setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
  }
}

export default connect(getDataFromStore, dispatchActionsToProps)(PurchaseOrdersFormVendorInfoView)